import { all, call, put, takeLatest } from 'redux-saga/effects'
import { enrollmentApi, reportsApi } from '@edulastic/api'
import { notification } from '@edulastic/common'

import { actions } from './actionReducers'

function* fetchProfileFilterDataSaga({ payload }) {
  try {
    const response = yield call(reportsApi.fetchProfileFilterData, payload)
    const filterData = response?.data?.result || response?.data || {}
    yield put(actions.fetchProfileFilterDataSuccess({ filterData }))
  } catch (error) {
    const msg =
      'Error getting profile filter data. Please try again after a few minutes.'
    notification({ msg })
    yield put(actions.fetchProfileFilterDataError({ error: msg }))
  }
}

function* fetchClassProfileSaga({ payload }) {
  try {
    const response = yield call(reportsApi.fetchClassProfileReport, payload)
    if (response?.data?.dataSizeExceeded) {
      yield put(actions.fetchClassProfileError({ error: response.data }))
      return
    }
    const classProfileData = response?.data?.result || response?.data || {}
    yield put(actions.fetchClassProfileSuccess({ classProfileData }))
  } catch (error) {
    const msg =
      'Error getting class profile report data. Please try again after a few minutes.'
    notification({ msg })
    yield put(actions.fetchClassProfileError({ error: msg }))
  }
}

function* fetchStudentProfileSaga({ payload }) {
  try {
    const response = yield call(
      reportsApi.fetchStudentProfileReportData,
      payload
    )
    if (response?.data?.dataSizeExceeded) {
      yield put(actions.fetchStudentProfileError({ error: response.data }))
      return
    }
    const studentProfileData = response?.data?.result || response?.data || {}
    yield put(actions.fetchStudentProfileSuccess({ studentProfileData }))
  } catch (error) {
    const msg =
      'Error getting student profile report data. Please try again after a few minutes.'
    notification({ msg })
    yield put(actions.fetchStudentProfileError({ error: msg }))
  }
}

function* fetchClassEnrollmentSaga({ payload }) {
  try {
    const { classId } = payload
    const result = yield call(enrollmentApi.fetch, classId)
    const { group, students = [] } = result || {}
    yield put(actions.fetchClassEnrollmentSuccess({ group, students }))
  } catch (error) {
    const msg =
      'Error loading class details. Please try again after a few minutes.'
    notification({ msg, type: 'error' })
    yield put(actions.fetchClassEnrollmentError({ error: msg }))
  }
}

export default function* watcherSaga() {
  yield all([
    takeLatest(
      actions.fetchProfileFilterDataRequest,
      fetchProfileFilterDataSaga
    ),
    takeLatest(actions.fetchClassProfileRequest, fetchClassProfileSaga),
    takeLatest(actions.fetchStudentProfileRequest, fetchStudentProfileSaga),
    takeLatest(actions.fetchClassEnrollmentRequest, fetchClassEnrollmentSaga),
  ])
}
